import React, { Component } from "react";
import { PostData } from "../../../../service/postData";
import { sendNotification } from "../../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { PaginationControl } from 'react-bootstrap-pagination-control'; 


let _UserSession = localStorage.getItem("vs_UserSession");
let _signingId = "0";
let _businessId = "0";
let _companyId = "0"; 

if (_UserSession!=undefined || _UserSession!=null) { 
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessId = _UserSession.tokenKey;
}

let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession!=undefined || _companySession!=null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _companyId = _companySession.company_id;
}

let columns = [
  {
    label: '#',
    field: 'srNo',
    width: 20,
    attributes: {
    'aria-controls': 'DataTable',
    'aria-label': '#',
    },
  },
  {
    label: "Date",
    field: "invoice_date",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Date",
    },
  },
  {
    label: "TXN TYPE",
    field: "txn_type",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "TXN TYPE",
    },
  },
  {
    label: "Ref No.",
    field: "ref_no",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Ref No.",
    },
  },
  {
    label: "Amount",
    field: "total_amount",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Total",
    },
  },
  {
    label: "Profit/ Loss",
    field: "profit_loss",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Profit/ Loss",
    },
  },
  // {
  //   label: "Action",
  //   field: "actionExtra",
  //   width: 100,
  // },
];

let _loader = "glb-ldr-prt active";
export default class dayBookReportPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoaded: true,
      statementArray: [],
      statementArrayFilter: [],
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,
      totalDebit: 0,
      totalCredit: 0,
      totalClosingBalance: 0,
      startDate : moment().startOf('month').format('YYYY-MM-DD'),
      endDate : moment().endOf('month').format('YYYY-MM-DD'),
      partyData : [],
      dateLabel: "",
      pageCount : 25,
      page : 1,
      totalCount  : 0,
      pageShow  : 0,
      party_id : 0,
      errors: {
        name: "",
      },
    };
  }

  async componentDidMount() {
    this.getPartyListData(this.state.company_id);
    if(this.state.party_id > 0){
      this.getPartyStatementData(this.state.party_id,this.state.page,this.state.pageCount);
    }
  }

  getPartyStatementData(party_id,_page,pageCount) {
    
    let _transArray = [];
    const requestData = JSON.stringify({
      business_id: this.state.businessId,
      company_id: this.state.company_id,
      party_id: party_id,
      isDateFilter: true,
      start_date: this.state.startDate,
      end_date: this.state.endDate,
      pageCount: pageCount,
      page: _page,
    });

    PostData(global.userPartyStatementList, requestData, "POST").then((result) =>{
      let responseJson = result;
        if (responseJson.success == false) {
          this.setState({
            statementArrayFilter: _transArray,
            statementArray: _transArray,
            isLoaded: true,
            totalDebit: 0,
            countList: 0,
            totalCredit  : 0,
            totalClosingBalance  : 0,
          });
        }else {
          if (responseJson.response) {
            _transArray = responseJson.response;
            _transArray.map((itm, i) => {
            });
          }          
          this.setState({
            statementArrayFilter: _transArray,
            statementArray: _transArray,
            isLoaded: true,
            totalDebit: responseJson.totalDebitAmount,
            totalCredit: responseJson.totalCreditAmount,
            totalClosingBalance: responseJson.totalClosingAmount,
            countList: responseJson.countList,
            totalCount: responseJson.totalCount,
            pageShow: responseJson.pageShow,
          });
        }

    }).catch((error)=>this.setState({error, isLoaded: false }));
  }
  
  changePartyFilter = (e) => {        
      this.setState({party_id : e.target.value});  
      if(e.target.value <= 0){
        alert("Please select atleast one party");
        return false;
      }else{
        this.getPartyStatementData(e.target.value,this.state.page,this.state.pageCount);
      }
  }
  getPartyListData() {
      let _partyData = [];
      let _url_GetData =
      global.userPartyList + "?company_id=" + this.state.company_id;
      PostData(_url_GetData, "", "GET").then((result) => {
          let responseJson = result;
          if (responseJson.success == false) {
              this.setState({ isLoaded: true });
          } else {
              if (responseJson.response) {
              _partyData = responseJson.response;
              }
              this.setState({ partyData: _partyData, isLoaded: true });
          }
      }).catch((error) => this.setState({ error, isLoaded: false}));
  }
  loadTranscListing() {
    let dataList = [];
    let rows = [];    
    let _i=0;
    if (this.state.isLoaded == true) {
      let _statementArrayFilter = this.state.statementArrayFilter;
      if (_statementArrayFilter.length > 0) {
        _statementArrayFilter.map((value, index) => {
        _i++; 
        let _pageAK = 1;
        rows.push({
          srNo: ((_pageAK - 1) * this.state.pageCount) + _i,
          invoice_date: moment(value.invoice_date).format("YYYY-MM-DD"),
          txn_type: value.txn_type,
          ref_no: value.ref_no,
          total_amount: value.total_amount,
          profit_loss: value.profit_loss,
        });
      
        });
      }
    }
    if (rows) {
      dataList = {
        columns: columns,
        rows: rows,
      };
    }
    return dataList;
  }

  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    });
    this.getPartyStatementData(this.state.party_id,this.state.page,this.state.pageCount);
  };

  clickToDelete(value, type) {
    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          className: "btn btn-danger",
          onClick: () => {
            const requestData = JSON.stringify({
              sale_id: value,
              type_value: type,
            });
            PostData(global.deleteSaleTransaction, requestData, "POST").then(
              (result) => {
                let responseJson = result;
                if (responseJson.success == false) {
                  sendNotification(
                    "Error Message 😓",
                    responseJson.message,
                    "danger"
                  );
                  return;
                } else {
                  sendNotification(
                    "Success Message 👍",
                    responseJson.message,
                    "success"
                  );
                  this.getPartyStatementData(this.state.party_id,this.state.page,this.state.pageCount);
                  return;
                }
              }
            );
          },
        },
        {
          label: "No",
          className: "btn btn-primary",
        },
      ],
    });
  }

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <h5># Party Statement</h5>
                <div className="block">
                  <div className="block-content" style={{ marginTop: "-20px" }}>
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-10">
                          <span>Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: {
                                format: "YYYY-MM-DD",
                              },
                              ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                  moment().subtract(1, "days").toDate(),
                                  moment().subtract(1, "days").toDate(),
                                ],
                                "This Week": [
                                  moment()
                                    .startOf("week")
                                    .format("YYYY-MM-DD"),
                                  moment().endOf("week").format("YYYY-MM-DD"),
                                ],
                                "This Month": [
                                  moment().startOf("month").toDate(),
                                  moment().endOf("month").toDate(),
                                ],
                                "Last Month": [
                                  moment()
                                    .subtract(1, "month")
                                    .startOf("month")
                                    .toDate(),
                                  moment()
                                    .subtract(1, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Quarter": [
                                  moment().startOf("month").toDate(),
                                  moment()
                                    .add(2, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                                "This Financial Year": [
                                  moment()
                                    .month("April")
                                    .startOf("month")
                                    .format("YYYY-MM-DD"),
                                  moment()
                                    .add(1, "year")
                                    .month("March")
                                    .endOf("month")
                                    .format("YYYY-MM-DD"),
                                ],
                              },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control col-7"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                          
                          <select onChange={this.changePartyFilter} className="form-control col-3" style={{display: 'inline-block',marginLeft: '4px'}}>
                              <option value="0">Select Party</option>
                              {this.state.partyData.map((item, index) => {
                                  let _sel = "";
                                  if (this.state.activePartyKey == item.party_id) {
                                  _sel = "selected";
                                  }
                                  return (
                                  <option
                                      key={index}
                                      value={item.party_id}
                                      selected={_sel}
                                  >
                                      {item.party_name}
                                  </option>
                                  );
                              })}
                          </select>
                        </div>
                        <br />
                      </div>                      
                      <div className="col-lg-12">
                          <div className="blockAreaList">
                              <div className="py-10 text-left" id="paidArea">
                                  <div className="text-muted">Total Debit</div>
                                  <div className="font-size-h5 font-w600">{numberFormat(this.state.totalDebit)}</div>
                              </div>
                          </div>
                          <div className="blockAreaListIcon"></div>
                          <div className="blockAreaList">
                              <div className="py-10 text-left" id="unpaidArea">
                                  <div className="text-muted">Total Credit</div>
                                  <div className="font-size-h5 font-w600">{numberFormat(this.state.totalCredit)}</div>
                              </div>
                          </div>
                          <div className="blockAreaListIcon"></div>    
                          <div className="blockAreaList">
                              <div className="py-10 text-left" id="totalArea">
                                  <div className="text-muted">Closing Balance</div>
                                  <div className="font-size-h5 font-w600">{numberFormat(this.state.totalClosingBalance)}</div>
                              </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="block" style={{ marginTop: "-60px" }}>
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                    <h2 className="block-title ml-10">Party Statement</h2>
                  </div>
                  <div className="block-content" id="tableData">                    
                    <MDBDataTableV5
                        hover
                        span
                        displayEntries={false}
                        entries={100}
                        pagingTop={false}
                        searchTop={false}
                        searchBottom={false}
                        info={false}
                        barReverse
                        data={this.loadTranscListing()}
                        />
                  </div>
                  
                  
                  <div style={{ float: "right", marginTop: "-15px" }}>
                      <div className="d-flex align-items-center justify-content-end">
                          <div className="d-flex align-items-center">
                          <div role="status" aria-live="polite"> Rows per page:</div>
                          </div>
                          <div className="d-flex align-items-center" >
                          <select className=" d-flex align-items-center custom-select custom-select-sm form-control form-control-sm"
                                  onChange={(event) => {
                                      event.preventDefault();
                                      const { name, value } = event.target;
                                      //this.setState({ pageCount: value, setPage: 1 });
                                      this.setState(prevState => ({
                                              pageCount : value,
                                              setPage : 1,
                                          }),
                                          () => {
                                              this.getPartyStatementData(this.state.party_id,1,value);
                                          });
                                  }}>
                              <option value="25">25</option>
                              <option value="50">50</option>
                              <option value="100">100</option>
                              <option value="500">500</option>
                              <option value="1000">1000</option>
                          </select>
                          </div>
                          <div className="d-flex align-items-center">
                          <div role="status" aria-live="polite"> Total: {this.state.totalCount}</div>
                          </div>
                      </div>
                  </div>
                  <div className="block-content">
                      <div style={{ float: "left", marginTop: "-45px" }}>
                      <PaginationControl
                          between={this.state.pageCount}
                          total={this.state.totalCount}
                          limit={this.state.pageCount}
                          changePage={(page) => {
                          this.setState({ setPage: page });
                          this.getPartyStatementData(this.state.party_id,page,this.state.pageCount);
                          }}
                          ellipsis={1}
                          activeClass={this.state.setPage}
                          page={this.state.setPage}
                      />
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
